import { buildElement, getHtmlElementByClassName } from '../../utils/element'
import { isBuyOnceId } from '../../models/buy-once'
import { widgetState } from '../../store/customizations/index'
import { getSelectedGroupId } from '../../store/selling-plans/getters'

export const renderSubscriptionPolicy = (mainElement: HTMLElement) => {
  if (!widgetState.customizations.subscriptionPolicy.shouldShow) {
    return
  }
  const subscriptionPolicy = getSubscriptionPolicyElement()
  mainElement.appendChild(subscriptionPolicy)
  addOpenSubscriptionToOnChangeEvent()
}

export const openSubscriptionPolicies = () => {
  const selectedGroupId = getSelectedGroupId()

  if (isBuyOnceId(selectedGroupId)) {
    getHtmlElementByClassName('yotpo-subscription-policy-wrapper').style.display = 'none'
    return
  }

  getHtmlElementByClassName('yotpo-subscription-policy-wrapper').style.display = 'block'
}

const addOpenSubscriptionToOnChangeEvent = () => {
  getHtmlElementByClassName('yotpo-selling-plans-wrapper')
    .addEventListener('change', () => openSubscriptionPolicies())
}

const getSubscriptionPolicyElement = (): HTMLElement => {
  const wrapper = buildElement('div', 'yotpo-subscription-policy-wrapper', {})
  const container = buildElement('div', `${widgetState.customizations.isReadOnly ? 'yotpo-subscription-policy-container yotpo-admin-preview' : 'yotpo-subscription-policy-container'}`, {})
  const main = buildElement('div', 'yotpo-subscription-policy', {})

  const textHeader = getTextHeader()
  main.appendChild(textHeader)

  const textMain = getMainText()
  main.appendChild(textMain)

  const textFooter = getTextFooter()
  if (textFooter) {
    main.appendChild(textFooter)
  }

  const radioStyle = buildElement('style', 'yotpo-subscription-policy-style', {})
  radioStyle.innerHTML = getStyles()

  container.appendChild(main)
  wrapper.appendChild(container)
  wrapper.appendChild(radioStyle)

  return wrapper
}

const getTextHeader = () => {
  const textHeader = buildElement('div', 'yotpo-subscription-policy-text-header', {})
  textHeader.innerHTML = getSelectedSellingPlanGroup()
  getHtmlElementByClassName('yotpo-selling-plans-wrapper').addEventListener('change', () => {
    textHeader.innerHTML = getSelectedSellingPlanGroup()
  })
  return textHeader
}

const getMainText = () => {
  const textMain = buildElement('div', 'yotpo-subscription-policy-text-main', {})
  textMain.innerHTML = widgetState.customizations.subscriptionPolicy.description
  return textMain
}

const getTextFooter = () => {
  const informationLink = widgetState.customizations.subscriptionPolicy.informationLink
  if (informationLink) {
    const defaultInformationLink = `${window.location.origin}/policies/subscription-policy.html?locale=en`
    const textFooter = buildElement('a', 'yotpo-subscription-policy-text-footer', {
      target: '_blank',
      href: informationLink || defaultInformationLink
    })
    textFooter.innerHTML = widgetState.customizations.subscriptionPolicy.footer
    return textFooter
  }
}

const getSelectedSellingPlanGroup = (): string => {
  const selectedLabel = document.querySelector('.yotpo-selected .yotpo-radio-label-text')
  if (selectedLabel) {
    return selectedLabel.innerHTML
  }
}

const getStyles = (): string => {
  return `
  .yotpo-widget-subscriptions-add-to-cart .yotpo-subscription-policy-wrapper {
    display: none;
    margin: 20px 0;
  }
  .yotpo-widget-subscriptions-add-to-cart .yotpo-subscription-policy-container {
    text-align: initial;
    width: 100%;
  }
  .yotpo-widget-subscriptions-add-to-cart .yotpo-subscription-policy-container.yotpo-admin-preview {
    margin: auto;
    max-width: 400px;
  }
  .yotpo-widget-subscriptions-add-to-cart .yotpo-subscription-policy {
    background: ${widgetState.customizations.styles.notSelectedRadio.backgroundColor};
    border-radius: 8px;
    display: grid;
    padding: 30px 20px;
  }
  .yotpo-widget-subscriptions-add-to-cart .yotpo-subscription-policy-text-header, .yotpo-subscription-policy-text-main, .yotpo-subscription-policy-text-footer {
    margin: 5px;
    font-style: normal;
    font-family: ${widgetState.customizations.styles.fontFamily.name};
    font-weight: ${widgetState.customizations.styles.fontFamily.weight || 500};
    line-height: 20px;
    width: 99%;
    color: ${widgetState.customizations.styles.colors.text.primary};
  }
  .yotpo-widget-subscriptions-add-to-cart .yotpo-subscription-policy-text-main, .yotpo-subscription-policy-text-footer {
    color: ${widgetState.customizations.styles.fontSize.primary};
  }
  .yotpo-widget-subscriptions-add-to-cart .yotpo-subscription-policy-text-header {
    color: ${widgetState.customizations.styles.colors.text.primary};
    font-size: ${widgetState.customizations.styles.fontSize.primary};
  }
  .yotpo-widget-subscriptions-add-to-cart .yotpo-subscription-policy-text-main {
    color: ${widgetState.customizations.styles.fontSize.primary};
    font-size: ${widgetState.customizations.styles.fontSize.primary};
  }
  .yotpo-widget-subscriptions-add-to-cart .yotpo-subscription-policy-text-footer {
    text-decoration: underline;
    font-size: ${widgetState.customizations.styles.fontSize.primary};
  }
  `
}
